let countDowns = document.querySelectorAll('.countdown-container');
countDowns.forEach(function(c, index) {
  c.classList.add(`count-${index}`)
});
countDowns.forEach(function(cd,index) {
  let daysEl, hourseEl, minsEl, secondsEl;
  if ( index == 0) {
    daysEl = document.querySelector(`.count-0 #days`);
    hoursEl = document.querySelector(`.count-0 #hours`);
    minsEl = document.querySelector(`.count-0 #mins`);
    secondsEl = document.querySelector(`.count-0 #seconds`);
  } else if(index == 1) {
    daysEl = document.querySelector(`.count-1 #days`);
    hoursEl = document.querySelector(`.count-1 #hours`);
    minsEl = document.querySelector(`.count-1 #mins`);
    secondsEl = document.querySelector(`.count-1 #seconds`);
  } else {
    daysEl = document.querySelector(`.count-2 #days`);
    hoursEl = document.querySelector(`.count-2 #hours`);
    minsEl = document.querySelector(`.count-2 #mins`);
    secondsEl = document.querySelector(`.count-2 #seconds`);
  }
  let dateEnd = cd.getAttribute('data-target-date');

  const targetDateObj = new Date(dateEnd);

  dateWithTimeZone = (timeZone, year, month, day, hour, minute, second) => {
    let date = new Date(Date.UTC(year, month, day, hour, minute, second));

    let utcDate = new Date(date.toLocaleString('en-US', { timeZone: "UTC" }));
    let tzDate = new Date(date.toLocaleString('en-US', { timeZone: timeZone }));
    let offset = utcDate.getTime() - tzDate.getTime();

    date.setTime( date.getTime() + offset );

    return date;
  };

  const targetDate = dateWithTimeZone("America/Los_Angeles",targetDateObj.getFullYear(),targetDateObj.getMonth(),targetDateObj.getDate(),0,0,0)

  function countdown() {
    let currentDate = new Date()
    const totalSeconds = (targetDate - currentDate) / 1000;
    let days = Math.floor(totalSeconds / 3600 / 24);
    let hours = Math.floor(totalSeconds / 3600) % 24;
    let mins = Math.floor(totalSeconds / 60) % 60;
    let seconds = Math.floor(totalSeconds) % 60;

    daysEl.innerHTML = days;
    hoursEl.innerHTML = formatTime(hours);
    minsEl.innerHTML = formatTime(mins);
    secondsEl.innerHTML = formatTime(seconds);
  }

  function formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }
  countdown();
  setInterval(countdown, 1000);
});

function updateClass() {
  let a = $(".announcement-bar.active");
  a.removeClass("active");
  a = a.next(".announcement-bar");
  if (a.length == 0)
    a = $(".announcement-bar").first();
    a.addClass("active");
}

$(document).ready(function() {
  setInterval(function() {
    updateClass();
  }, 5000);
});


(()=>{
  const customUserWay = document.getElementById("CustomTrigger");
  customUserWay.addEventListener("click", function() {
    document.getElementById("userwayAccessibilityIcon").click();
  });
})();


